import _slicedToArray from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import windowExists from '../../helpers/window-exists';
import defaultTheme from '../../theme/default';
export var ThemeContext = createContext({
  theme: defaultTheme
});
export var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  return _jsx(ThemeContext.Provider, {
    value: value,
    children: children
  });
};
export function useTheme() {
  return useContext(ThemeContext);
}
export var useThemeMode = function useThemeMode(usePreferences) {
  var _useState = useState('light'),
    _useState2 = _slicedToArray(_useState, 2),
    mode = _useState2[0],
    setModeState = _useState2[1];
  var savePreference = function savePreference(mode) {
    return localStorage.setItem('theme', mode);
  };
  var getPreference = function getPreference() {
    return localStorage.getItem('theme') || getPrefersColorScheme();
  };
  var userPreferenceIsDark = function userPreferenceIsDark() {
    var _window$matchMedia, _window;
    return (_window$matchMedia = (_window = window).matchMedia) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.call(_window, '(prefers-color-scheme: dark)').matches;
  };
  var getPrefersColorScheme = function getPrefersColorScheme() {
    return userPreferenceIsDark() ? 'dark' : 'light';
  };
  var toggleMode = function toggleMode() {
    var newMode = mode === 'dark' ? 'light' : 'dark';
    setMode(newMode);
    setModeState(newMode);
  };
  var setMode = function setMode(mode) {
    savePreference(mode);
    if (!windowExists()) {
      return;
    }
    if (mode === 'dark') {
      document.documentElement.classList.add('dark');
      return;
    }
    document.documentElement.classList.remove('dark');
  };
  if (usePreferences) {
    useEffect(function () {
      return setModeState(getPreference());
    }, []);
    useEffect(function () {
      return setMode(mode);
    }, [mode]);
  }
  return [mode, setModeState, toggleMode];
};